import * as Sentry from '@sentry/react';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { onCLS, onINP, onLCP } from 'web-vitals';
import './index.css'
import App from './App.jsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE || 'unknown',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  beforeSend(event, hint) {
    // Sessão expirada (401) é fluxo normal — o request() lança para não
    // devolver undefined ao chamador, mas isso não é defeito para reportar.
    if (hint?.originalException?.sessionExpired) return null;
    // Drop errors from browser extensions (chrome-extension://, moz-extension://)
    const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
    if (frames.some(f => /^(chrome|moz|safari)-extension:\/\//.test(f.filename ?? ''))) return null;
    // Strip CNPJ/CPF patterns from message to avoid leaking PII in error text
    const cnpjCpf = /\b(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{3}\.\d{3}\.\d{3}-\d{2})\b/g;
    if (event.message) event.message = event.message.replace(cnpjCpf, '[REDACTED]');
    return event;
  },
});

// ZYN-223: Web Vitals — reporta LCP, CLS, INP para Sentry e console (dev)
function reportVital({ name, value, rating }) {
  if (import.meta.env.DEV) {
    console.log(`[Web Vital] ${name}: ${Math.round(value)} (${rating})`);
  }
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.captureEvent({
      type: 'transaction',
      level: 'info',
      message: `web-vital:${name}`,
      extra: { value: Math.round(value), rating },
    });
  }
}
onLCP(reportVital);
onCLS(reportVital);
onINP(reportVital);

// ZYN-64: Register service worker for PWA + push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(reg => console.log('[SW] Registered, scope:', reg.scope))
      .catch(err => console.warn('[SW] Registration failed:', err));
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
